/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const Query_Keys = {
  restaurant_groups_dropdown: (params = {}) => ['restaurant_groups_dropdown', params],
  restaurants_dropdown: (params) => ['restaurants_dropdown', params],
  employees_dropdown: (params) => ['employees_dropdown', params],
  applied_discount: (params) => ['applied_discount', params],
  orders: (params) => ['orders', params],
  active_guests_list: (params) => ['active_guests_list', params],
  employee_discounts: (params) => ['employee_discounts', params],
  employee_discounts_analytics: (params) => ['employee_discounts_analytics', params],
  discount_cards_dropdown: (params) => ['discount_cards_dropdown', params],
  employee_discount_report: (params) => ["employee_discount_report", params],
  cross_restaurant_data: (params) => ['cross_restaurant_data', params],
  tip_compliance: (params) => ['tip_compliance', params],
  named_user_discounts: (params) => ['named_user_discounts', params],
  classified_discount_records: (params) => ['classified_discount_records', params],
  discount_reports: (params) => ['discount_reports', params],
  discount_report_summary: (params) => ['discount_report_summary', params],
  discount_report_breakdown: (params) => ['discount_report_breakdown', params],
  configured_discounts_dropdown: (params) => ['configured_discounts_dropdown', params],
  check_in_compliance: (params) => ['check_in_compliance', params],
  check_in_compliance_summary: (params) => ['check_in_compliance_summary', params],
  check_in_compliance_eligible_orders: (params) => ['check_in_compliance_eligible_orders', params],
  check_in_compliance_reconciled_check_ins: (params) => ['check_in_compliance_reconciled_check_ins', params],
  managed_configured_discounts_dropdown: (params) => ['managed_configured_discounts_dropdown', params],
  billing_report: (params) => ['billing_report', params],
  billing_report_orders: (params) => ['billing_report_orders', params],
  employee_visibility: (params) => ['employee_visibility', params],
  uninvited_guests: (params) => ['uninvited_guests', params],
  global_employee_search: (params) => ['global_employee_search', params],
  insights: (params) => ['insights', params],
  employee_time_entries: (params) => ['employee_time_entries', params],
  mobile_user_activity: (params) => ['mobile_user_activity', params],
  mobile_user_activity_date_presets: ['mobile_user_activity_date_presets'],
  user_activity_log: (params) => ['user_activity_log', params],
  archived_employees: (params) => ['archived_employees', params],
  restaurants: (params) => ['restaurants', params],
  back_office_restaurants_dropdown: (params) => ['back_office_restaurants_dropdown', params],
  audit_logs: (params) => ['audit_logs', params],
  audit_logs_analytics: (params) => ['audit_logs_analytics', params],
  audit_log: (params) => ['audit_log', params],
  audit_import: (params) => ['audit_import', params],
  discount_card_log_cards: (params) => ['discount_card_log_cards', params],
  admin_user_dropdown: ['admin_user_dropdown'],
  discount_card_logs: (params) => ['discount_card_logs', params],
  restaurant_groups: (params) => ['restaurant_groups', params],
  dashboard_overview: (params) => ['dashboard_overview', params],
  dashboard_audience: (params) => ['dashboard_audience', params],
  audience_per_restaurant: (params) => ['audience_per_restaurant', params],
  dashboard_engagement: (params) => ['dashboard_engagement', params],
  dashboard_total_sales: (params) => ['dashboard_total_sales', params],
  dashboard_insights: (params) => ['dashboard_insights', params],
  cuisines_dropdown: (params = {}) => ['cuisines_dropdown', params],
  show_restaurant: (params) => ['show_restaurant', params],
  toast_credential_logs: (params) => ['toast_credential_logs', params],
  discount_cards: (params) => ['discount_cards', params],
  industry_discount_cards: (params) => ['industry_discount_cards', params],
  eligible_industry_discount_cards: (params) => ['eligible_industry_discount_cards', params],
  show_discount_card: (params) => ['show_discount_card', params],
  discount_card_variant_assignable_guests_list: (params) => ['discount_card_variant_assignable_guests_list', params],
  permission_restaurant_group: (params) => ['permission_restaurant_group', params],
  create_restaurant_dropdown: (params) => ['create_restaurant_dropdown', params],
  jobs: (params) => ['jobs', params],
  job_description: (params) => ['job_description', params],
  jobs_dropdown: (params) => ['jobs_dropdown', params],
  modifiers: (params) => ['modifiers', params],
  employees: (params) => ['employees', params],
  delete_network_guest: (params) => ['delete_network_guest', params],
  employee_list: ['employee_list'],
  network_guest_discount_cards: ['network_guest_discount_cards'],
  network_guests: (params) => ['network_guests', params],
  employees_ignored: (params) => ['employees_ignored', params],
  admins: (params) => ['admins', params],
  configuration: (params) => ['configuration', params],
  employee_groups: (params) => ['employee_groups', params],
  active_users_list: (params) => ['active_users_list', params],
  group_members: (params) => ['group_members', params],
  employee_group: (params) => ['employee_group', params],
  configured_discounts: (params) => ['configured_discounts', params],
  search_guests: (params) => ['search_guests', params],
  guest_details: (params) => ['guest_details', params],
  guest_orders: (params) => ['guest_orders', params],
  guest_spend_breakdown: (params) => ['guest_spend_breakdown', params],
  guest_activity_log: (params) => ['guest_activity_log', params],
  order_and_visits: (params) => ['order_and_visits', params],
  top_restaurants: (params) => ['top_restaurants', params],
  associated_guest_restaurants: (params) => ['associated_guest_restaurants', params],
  applied_discounts: (params) => ['applied_discounts', params],
  dynamic_discount_events: (params) => ['dynamic_discount_events', params],
  dynamic_discount_events_matrix: (params) => ['dynamic_discount_events_matrix', params],
  restaurant_sub_groups_dropdown: (params = {}) => ['restaurant_sub_groups_dropdown', params],
  configured_restaurants: (params) => ['configured_restaurants', params],
  import_logs: (params) => ['import_logs', params],
  import_log_metric: (params) => ['import_log_metric', params],
  import_conflict: (params) => ['import_conflict', params],
  resolved_conflict: (params) => ['resolved_conflict', params],
  conflicted_employees: (params) => ['conflicted_employees', params],
  convertible_restaurants: (params) => ['convertible_restaurants', params],
  policy_engines: (params) => ['policy_engines', params],
  show_policy_engine: (params) => ['show_policy_engine', params],
  check_active_policy: (params) => ['check_active_policy', params],
  inactivity_review: (params) => ['inactivity_review', params],
  manual_users_dropdown: (params = {}) => ['manual_users_dropdown', params],
  labor_reports: (params) => ['labor_reports', params],
  labor_report_summary: (params) => ['labor_report_summary', params],
  daily_logbooks: (params) => ['daily_logbooks', params],
  daily_logbook_detail: (params) => ['daily_logbook_detail', params],
  daily_sales_reports: (params) => ['daily_sales_reports', params],
  revenue_centers: (params) => ['revenue_centers', params],
  sales_categories: (params) => ['sales_categories', params],
  meal_periods: (params) => ['meal_periods', params],
  csv_export_status: (id) => ['csv_export_status', id]
}
